import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonApp, IonRouterOutlet } from "@ionic/vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), { style: {"background":"url(//app.food-futures.org/img/app-background-image.924e9041.webp)"} }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRouterOutlet), {
        id: "main-content",
        class: "m-2"
      })
    ]),
    _: 1
  }))
}
}

})